webpackJsonp([103038246049810],{

/***/ "./assets/foam-hand.png":
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/foam-hand.aaac9c57.png";

/***/ }),

/***/ "./matthew-nest.png":
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/matthew-nest.2bf5b3c2.png";

/***/ }),

/***/ "./src/components/PublicationStyles.js":
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports.TrustGrid = exports.BiotechCards = exports.Editorial = exports.ScientificTable = undefined;
	
	var _templateObject = _taggedTemplateLiteralLoose(["\n  max-width: 760px;\n  margin: 0 auto;\n  border-top: 2px solid ", ";\n"], ["\n  max-width: 760px;\n  margin: 0 auto;\n  border-top: 2px solid ", ";\n"]),
	    _templateObject2 = _taggedTemplateLiteralLoose(["\n  display: flex;\n  align-items: baseline;\n  padding: 1.25rem 0;\n  border-bottom: 1px solid ", ";\n  gap: 1.5rem;\n\n  ", ";\n"], ["\n  display: flex;\n  align-items: baseline;\n  padding: 1.25rem 0;\n  border-bottom: 1px solid ", ";\n  gap: 1.5rem;\n\n  ", ";\n"]),
	    _templateObject3 = _taggedTemplateLiteralLoose(["\n    flex-direction: column;\n    gap: 0.25rem;\n  "], ["\n    flex-direction: column;\n    gap: 0.25rem;\n  "]),
	    _templateObject4 = _taggedTemplateLiteralLoose(["\n  font-family: \"Courier New\", Courier, monospace;\n  font-size: 0.85rem;\n  color: ", ";\n  min-width: 3rem;\n  flex-shrink: 0;\n"], ["\n  font-family: \"Courier New\", Courier, monospace;\n  font-size: 0.85rem;\n  color: ", ";\n  min-width: 3rem;\n  flex-shrink: 0;\n"]),
	    _templateObject5 = _taggedTemplateLiteralLoose(["\n  font-family: \"Avenir Next\", sans-serif;\n  font-size: 0.95rem;\n  line-height: 1.55;\n  color: ", ";\n"], ["\n  font-family: \"Avenir Next\", sans-serif;\n  font-size: 0.95rem;\n  line-height: 1.55;\n  color: ", ";\n"]),
	    _templateObject6 = _taggedTemplateLiteralLoose(["\n  font-style: italic;\n  color: ", ";\n"], ["\n  font-style: italic;\n  color: ", ";\n"]),
	    _templateObject7 = _taggedTemplateLiteralLoose(["\n  max-width: 680px;\n  width: 100%;\n  margin: 0 auto;\n  padding: 0;\n  border-top: 1px solid #eaeaea;\n  border-bottom: 1px solid #eaeaea;\n  overflow: hidden;\n"], ["\n  max-width: 680px;\n  width: 100%;\n  margin: 0 auto;\n  padding: 0;\n  border-top: 1px solid #eaeaea;\n  border-bottom: 1px solid #eaeaea;\n  overflow: hidden;\n"]),
	    _templateObject8 = _taggedTemplateLiteralLoose(["\n  display: flex;\n  align-items: baseline;\n  padding: 1.5rem 0;\n  border-bottom: 1px solid #eaeaea;\n  gap: 1.5rem;\n\n  &:last-child {\n    border-bottom: none;\n  }\n\n  ", ";\n"], ["\n  display: flex;\n  align-items: baseline;\n  padding: 1.5rem 0;\n  border-bottom: 1px solid #eaeaea;\n  gap: 1.5rem;\n\n  &:last-child {\n    border-bottom: none;\n  }\n\n  ", ";\n"]),
	    _templateObject9 = _taggedTemplateLiteralLoose(["\n  flex: 1;\n  min-width: 0;\n  overflow-wrap: break-word;\n  word-break: break-word;\n"], ["\n  flex: 1;\n  min-width: 0;\n  overflow-wrap: break-word;\n  word-break: break-word;\n"]),
	    _templateObject10 = _taggedTemplateLiteralLoose(["\n  font-family: Palatino, \"Palatino Linotype\", Georgia, serif;\n  font-size: 1.05rem;\n  font-weight: bold;\n  line-height: 1.5;\n  color: ", ";\n  margin-bottom: 0.35rem;\n"], ["\n  font-family: Palatino, \"Palatino Linotype\", Georgia, serif;\n  font-size: 1.05rem;\n  font-weight: bold;\n  line-height: 1.5;\n  color: ", ";\n  margin-bottom: 0.35rem;\n"]),
	    _templateObject11 = _taggedTemplateLiteralLoose(["\n  font-family: \"Avenir Next\", sans-serif;\n  font-size: 0.8rem;\n  color: ", ";\n  letter-spacing: 0.02em;\n\n  ", ";\n"], ["\n  font-family: \"Avenir Next\", sans-serif;\n  font-size: 0.8rem;\n  color: ", ";\n  letter-spacing: 0.02em;\n\n  ", ";\n"]),
	    _templateObject12 = _taggedTemplateLiteralLoose(["\n    font-size: 0.95rem;\n  "], ["\n    font-size: 0.95rem;\n  "]),
	    _templateObject13 = _taggedTemplateLiteralLoose(["\n  font-family: \"Avenir Next\", sans-serif;\n  font-size: 0.8rem;\n  color: ", ";\n  text-decoration: underline;\n  display: inline-block;\n  margin-top: 0.25rem;\n  overflow-wrap: break-word;\n  word-break: break-all;\n  max-width: 100%;\n\n  &:hover {\n    color: ", ";\n  }\n\n  ", ";\n"], ["\n  font-family: \"Avenir Next\", sans-serif;\n  font-size: 0.8rem;\n  color: ", ";\n  text-decoration: underline;\n  display: inline-block;\n  margin-top: 0.25rem;\n  overflow-wrap: break-word;\n  word-break: break-all;\n  max-width: 100%;\n\n  &:hover {\n    color: ", ";\n  }\n\n  ", ";\n"]),
	    _templateObject14 = _taggedTemplateLiteralLoose(["\n  max-width: 720px;\n  margin: 0 auto;\n  display: flex;\n  flex-direction: column;\n  gap: 1rem;\n"], ["\n  max-width: 720px;\n  margin: 0 auto;\n  display: flex;\n  flex-direction: column;\n  gap: 1rem;\n"]),
	    _templateObject15 = _taggedTemplateLiteralLoose(["\n  border-left: 3px solid ", ";\n  background: ", ";\n  padding: 1.25rem 1.5rem;\n  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.06);\n  border-radius: 0 4px 4px 0;\n  transition: box-shadow 200ms;\n\n  &:hover {\n    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);\n  }\n"], ["\n  border-left: 3px solid ", ";\n  background: ", ";\n  padding: 1.25rem 1.5rem;\n  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.06);\n  border-radius: 0 4px 4px 0;\n  transition: box-shadow 200ms;\n\n  &:hover {\n    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);\n  }\n"]),
	    _templateObject16 = _taggedTemplateLiteralLoose(["\n  font-family: \"Avenir Next\", sans-serif;\n  font-size: 0.95rem;\n  font-weight: 600;\n  line-height: 1.45;\n  color: ", ";\n  margin-bottom: 0.5rem;\n"], ["\n  font-family: \"Avenir Next\", sans-serif;\n  font-size: 0.95rem;\n  font-weight: 600;\n  line-height: 1.45;\n  color: ", ";\n  margin-bottom: 0.5rem;\n"]),
	    _templateObject17 = _taggedTemplateLiteralLoose(["\n  display: flex;\n  align-items: center;\n  gap: 0.75rem;\n  flex-wrap: wrap;\n"], ["\n  display: flex;\n  align-items: center;\n  gap: 0.75rem;\n  flex-wrap: wrap;\n"]),
	    _templateObject18 = _taggedTemplateLiteralLoose(["\n  font-family: \"Avenir Next\", sans-serif;\n  font-size: 0.75rem;\n  font-weight: 600;\n  background: ", ";\n  color: white;\n  padding: 0.15rem 0.5rem;\n  border-radius: 3px;\n"], ["\n  font-family: \"Avenir Next\", sans-serif;\n  font-size: 0.75rem;\n  font-weight: 600;\n  background: ", ";\n  color: white;\n  padding: 0.15rem 0.5rem;\n  border-radius: 3px;\n"]),
	    _templateObject19 = _taggedTemplateLiteralLoose(["\n  font-family: \"Avenir Next\", sans-serif;\n  font-size: 0.8rem;\n  color: ", ";\n"], ["\n  font-family: \"Avenir Next\", sans-serif;\n  font-size: 0.8rem;\n  color: ", ";\n"]),
	    _templateObject20 = _taggedTemplateLiteralLoose(["\n  max-width: 760px;\n  margin: 0 auto;\n  border: 1px solid ", ";\n  border-radius: 4px;\n  overflow: hidden;\n"], ["\n  max-width: 760px;\n  margin: 0 auto;\n  border: 1px solid ", ";\n  border-radius: 4px;\n  overflow: hidden;\n"]),
	    _templateObject21 = _taggedTemplateLiteralLoose(["\n  display: flex;\n  background: ", ";\n  color: ", ";\n  font-family: \"Avenir Next\", sans-serif;\n  font-size: 0.75rem;\n  font-weight: 600;\n  text-transform: uppercase;\n  letter-spacing: 0.08em;\n  padding: 0.6rem 1rem;\n\n  & > span:first-child {\n    flex: 1;\n  }\n  & > span:last-child {\n    width: 160px;\n    text-align: right;\n  }\n\n  ", ";\n"], ["\n  display: flex;\n  background: ", ";\n  color: ", ";\n  font-family: \"Avenir Next\", sans-serif;\n  font-size: 0.75rem;\n  font-weight: 600;\n  text-transform: uppercase;\n  letter-spacing: 0.08em;\n  padding: 0.6rem 1rem;\n\n  & > span:first-child {\n    flex: 1;\n  }\n  & > span:last-child {\n    width: 160px;\n    text-align: right;\n  }\n\n  ", ";\n"]),
	    _templateObject22 = _taggedTemplateLiteralLoose(["\n    & > span:last-child { display: none; }\n  "], ["\n    & > span:last-child { display: none; }\n  "]),
	    _templateObject23 = _taggedTemplateLiteralLoose(["\n  display: flex;\n  align-items: baseline;\n  padding: 0.85rem 1rem;\n  font-family: \"Avenir Next\", sans-serif;\n  font-size: 0.9rem;\n  line-height: 1.5;\n  background: ", ";\n  color: ", ";\n\n  & > div:first-child {\n    flex: 1;\n  }\n  & > div:last-child {\n    width: 160px;\n    text-align: right;\n    font-size: 0.8rem;\n    color: ", ";\n  }\n\n  ", ";\n"], ["\n  display: flex;\n  align-items: baseline;\n  padding: 0.85rem 1rem;\n  font-family: \"Avenir Next\", sans-serif;\n  font-size: 0.9rem;\n  line-height: 1.5;\n  background: ", ";\n  color: ", ";\n\n  & > div:first-child {\n    flex: 1;\n  }\n  & > div:last-child {\n    width: 160px;\n    text-align: right;\n    font-size: 0.8rem;\n    color: ", ";\n  }\n\n  ", ";\n"]),
	    _templateObject24 = _taggedTemplateLiteralLoose(["\n    flex-direction: column;\n    & > div:last-child {\n      width: 100%;\n      text-align: left;\n      margin-top: 0.25rem;\n    }\n  "], ["\n    flex-direction: column;\n    & > div:last-child {\n      width: 100%;\n      text-align: left;\n      margin-top: 0.25rem;\n    }\n  "]),
	    _templateObject25 = _taggedTemplateLiteralLoose(["\n  font-weight: 600;\n"], ["\n  font-weight: 600;\n"]),
	    _templateObject26 = _taggedTemplateLiteralLoose(["\n  color: ", ";\n"], ["\n  color: ", ";\n"]);
	
	var _react = __webpack_require__("./node_modules/gatsby-plugin-react-next/node_modules/react/index.js");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _styledComponents = __webpack_require__("./node_modules/styled-components/lib/index.js");
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _taggedTemplateLiteralLoose(strings, raw) { strings.raw = raw; return strings; }
	
	// ============================================================
	// Sample data used by all style variants
	// ============================================================
	var defaultPublications = [{
	  authors: "Thirumalai A, Page ST",
	  title: "Recent developments in male contraception",
	  journal: "Drugs",
	  year: 2019,
	  detail: "79(1):11-20"
	}, {
	  authors: "Yuen F, et al.",
	  title: "Combined nestorone\u2013testosterone gel suppresses serum gonadotropins to concentrations associated with effective contraception in men",
	  journal: "J Clin Endocrinol Metab",
	  year: 2020,
	  detail: "105(4):e1230-e1240"
	}, {
	  authors: "Long JE, et al.",
	  title: "Hormonal male contraception: progress and challenges",
	  journal: "Best Pract Res Clin Obstet Gynaecol",
	  year: 2023,
	  detail: "90:102386"
	}, {
	  authors: "Population Council",
	  title: "Phase 2b clinical trial results for NES/T combination gel",
	  journal: "Clinical Study Report",
	  year: 2024,
	  detail: ""
	}, {
	  authors: "Contraline, Inc.",
	  title: "NES/T Gel licensing and Phase 3 development plans",
	  journal: "Press Release",
	  year: 2025,
	  detail: ""
	}];
	
	// ============================================================
	// STYLE A — "Scientific Table"
	// Structured rows with year column, horizontal rules, monospace
	// accents. Feels like a reference database or PubMed result set.
	// ============================================================
	
	var TableWrapper = _styledComponents2.default.div(_templateObject, function (p) {
	  return p.theme.colors.dark;
	});
	
	var TableRow = _styledComponents2.default.div(_templateObject2, function (p) {
	  return p.theme.colors.greyAccent;
	}, function (p) {
	  return p.theme.media.mobile(_templateObject3);
	});
	
	var TableYear = _styledComponents2.default.span(_templateObject4, function (p) {
	  return p.theme.colors.greyDark;
	});
	
	var TableBody = _styledComponents2.default.div(_templateObject5, function (p) {
	  return p.theme.colors.dark;
	});
	
	var TableJournal = _styledComponents2.default.span(_templateObject6, function (p) {
	  return p.theme.colors.greyTimeline;
	});
	
	var ScientificTable = exports.ScientificTable = function ScientificTable(_ref) {
	  var publications = _ref.publications;
	
	  var pubs = publications || defaultPublications;
	  return _react2.default.createElement(
	    TableWrapper,
	    null,
	    pubs.map(function (pub, i) {
	      return _react2.default.createElement(
	        TableRow,
	        { key: i },
	        _react2.default.createElement(
	          TableYear,
	          null,
	          pub.year
	        ),
	        _react2.default.createElement(
	          TableBody,
	          null,
	          pub.authors,
	          ". \u201C",
	          pub.title,
	          ".\u201D",
	          " ",
	          _react2.default.createElement(
	            TableJournal,
	            null,
	            pub.journal,
	            pub.detail ? ". " + pub.detail : ""
	          ),
	          "."
	        )
	      );
	    })
	  );
	};
	
	// ============================================================
	// STYLE B — "Editorial"
	// Serif type, generous whitespace, large pull-quote style title,
	// subtle numbering. Inspired by NEJM / Nature editorial pages.
	// ============================================================
	
	var EditorialList = _styledComponents2.default.div(_templateObject7);
	
	var EditorialRow = _styledComponents2.default.div(_templateObject8, function (p) {
	  return p.theme.media.mobile(_templateObject3);
	});
	
	var EditorialYear = _styledComponents2.default.span(_templateObject4, function (p) {
	  return p.theme.colors.greyDark;
	});
	
	var EditorialBody = _styledComponents2.default.div(_templateObject9);
	
	var EditorialTitle = _styledComponents2.default.div(_templateObject10, function (p) {
	  return p.theme.colors.dark;
	});
	
	var EditorialMeta = _styledComponents2.default.div(_templateObject11, function (p) {
	  return p.theme.colors.greyDark;
	}, function (p) {
	  return p.theme.media.mobile(_templateObject12);
	});
	
	var DoiLink = _styledComponents2.default.a(_templateObject13, function (p) {
	  return p.theme.colors.greyDark;
	}, function (p) {
	  return p.theme.colors.dark;
	}, function (p) {
	  return p.theme.media.mobile(_templateObject12);
	});
	
	var Editorial = exports.Editorial = function Editorial(_ref2) {
	  var publications = _ref2.publications;
	
	  var pubs = (publications || defaultPublications).slice().sort(function (a, b) {
	    return (b.year || 0) - (a.year || 0);
	  });
	  return _react2.default.createElement(
	    EditorialList,
	    null,
	    pubs.map(function (pub, i) {
	      return _react2.default.createElement(
	        EditorialRow,
	        { key: i },
	        _react2.default.createElement(
	          EditorialYear,
	          null,
	          pub.year
	        ),
	        _react2.default.createElement(
	          EditorialBody,
	          null,
	          _react2.default.createElement(
	            EditorialTitle,
	            null,
	            pub.title
	          ),
	          _react2.default.createElement(
	            EditorialMeta,
	            null,
	            pub.authors,
	            " \xB7 ",
	            _react2.default.createElement(
	              "em",
	              null,
	              pub.journal
	            ),
	            pub.detail ? ", " + pub.detail : ""
	          ),
	          pub.doi && _react2.default.createElement(
	            "div",
	            null,
	            _react2.default.createElement(
	              DoiLink,
	              { href: pub.doi, target: "_blank", rel: "noopener noreferrer" },
	              pub.doi
	            )
	          ),
	          pub.link && !pub.doi && _react2.default.createElement(
	            "div",
	            null,
	            _react2.default.createElement(
	              DoiLink,
	              { href: pub.link, target: "_blank", rel: "noopener noreferrer" },
	              pub.link
	            )
	          )
	        )
	      );
	    })
	  );
	};
	
	// ============================================================
	// STYLE C — "Biotech Card"
	// Teal left-border accent cards on light background. Clean sans-
	// serif, year badges, high contrast. Conveys clinical trust.
	// ============================================================
	
	var CardList = _styledComponents2.default.div(_templateObject14);
	
	var PubCard = _styledComponents2.default.div(_templateObject15, function (p) {
	  return p.theme.colors.teal;
	}, function (p) {
	  return p.theme.colors.white;
	});
	
	var CardTitle = _styledComponents2.default.div(_templateObject16, function (p) {
	  return p.theme.colors.dark;
	});
	
	var CardFooter = _styledComponents2.default.div(_templateObject17);
	
	var YearBadge = _styledComponents2.default.span(_templateObject18, function (p) {
	  return p.theme.colors.teal;
	});
	
	var CardMeta = _styledComponents2.default.span(_templateObject19, function (p) {
	  return p.theme.colors.greyDark;
	});
	
	var BiotechCards = exports.BiotechCards = function BiotechCards(_ref3) {
	  var publications = _ref3.publications;
	
	  var pubs = publications || defaultPublications;
	  return _react2.default.createElement(
	    CardList,
	    null,
	    pubs.map(function (pub, i) {
	      return _react2.default.createElement(
	        PubCard,
	        { key: i },
	        _react2.default.createElement(
	          CardTitle,
	          null,
	          pub.title
	        ),
	        _react2.default.createElement(
	          CardFooter,
	          null,
	          _react2.default.createElement(
	            YearBadge,
	            null,
	            pub.year
	          ),
	          _react2.default.createElement(
	            CardMeta,
	            null,
	            pub.authors,
	            " \xB7 ",
	            _react2.default.createElement(
	              "em",
	              null,
	              pub.journal
	            ),
	            pub.detail ? " " + pub.detail : ""
	          )
	        )
	      );
	    })
	  );
	};
	
	// ============================================================
	// STYLE D — "Trust Grid"
	// Two-column grid with dark header bar, alternating row tones,
	// and a compact data-dense layout. Institutional / FDA-doc feel.
	// ============================================================
	
	var GridOuter = _styledComponents2.default.div(_templateObject20, function (p) {
	  return p.theme.colors.greyAccent;
	});
	
	var GridHeader = _styledComponents2.default.div(_templateObject21, function (p) {
	  return p.theme.colors.dark;
	}, function (p) {
	  return p.theme.colors.white;
	}, function (p) {
	  return p.theme.media.mobile(_templateObject22);
	});
	
	var GridRow = _styledComponents2.default.div(_templateObject23, function (p) {
	  return p.even ? p.theme.colors.greyLight : p.theme.colors.white;
	}, function (p) {
	  return p.theme.colors.dark;
	}, function (p) {
	  return p.theme.colors.greyDark;
	}, function (p) {
	  return p.theme.media.mobile(_templateObject24);
	});
	
	var GridTitle = _styledComponents2.default.span(_templateObject25);
	
	var GridAuthors = _styledComponents2.default.span(_templateObject26, function (p) {
	  return p.theme.colors.greyTimeline;
	});
	
	var TrustGrid = exports.TrustGrid = function TrustGrid(_ref4) {
	  var publications = _ref4.publications;
	
	  var pubs = publications || defaultPublications;
	  return _react2.default.createElement(
	    GridOuter,
	    null,
	    _react2.default.createElement(
	      GridHeader,
	      null,
	      _react2.default.createElement(
	        "span",
	        null,
	        "Publication"
	      ),
	      _react2.default.createElement(
	        "span",
	        null,
	        "Source"
	      )
	    ),
	    pubs.map(function (pub, i) {
	      return _react2.default.createElement(
	        GridRow,
	        { key: i, even: i % 2 === 1 },
	        _react2.default.createElement(
	          "div",
	          null,
	          _react2.default.createElement(
	            GridTitle,
	            null,
	            pub.title
	          ),
	          _react2.default.createElement("br", null),
	          _react2.default.createElement(
	            GridAuthors,
	            null,
	            pub.authors
	          )
	        ),
	        _react2.default.createElement(
	          "div",
	          null,
	          _react2.default.createElement(
	            "em",
	            null,
	            pub.journal
	          ),
	          pub.detail ? ", " + pub.detail : "",
	          " (",
	          pub.year,
	          ")"
	        )
	      );
	    })
	  );
	};

/***/ }),

/***/ "./node_modules/babel-loader/lib/index.js?{\"presets\":[\"/vercel/path0/node_modules/babel-preset-react-app/index.js\",[\"/vercel/path0/node_modules/babel-preset-env/lib/index.js\",{\"loose\":true,\"uglify\":true,\"modules\":\"commonjs\",\"targets\":{\"browsers\":[\"> 1%\",\"IE >= 9\",\"Safari >= 9\",\"last 2 versions\"]},\"exclude\":[\"transform-regenerator\",\"transform-es2015-typeof-symbol\"]}],\"/vercel/path0/node_modules/babel-preset-stage-0/lib/index.js\",\"/vercel/path0/node_modules/babel-preset-react/lib/index.js\",[\"/vercel/path0/node_modules/babel-preset-env/lib/index.js\",{\"loose\":true,\"uglify\":true,\"modules\":\"commonjs\",\"targets\":{\"browsers\":[\"> 1%\",\"IE >= 9\",\"Safari >= 9\",\"last 2 versions\"]},\"exclude\":[\"transform-regenerator\",\"transform-es2015-typeof-symbol\"]}],\"/vercel/path0/node_modules/babel-preset-stage-0/lib/index.js\",\"/vercel/path0/node_modules/babel-preset-react/lib/index.js\"],\"plugins\":[\"/vercel/path0/node_modules/gatsby/dist/utils/babel-plugin-extract-graphql.js\",\"/vercel/path0/node_modules/gatsby/dist/utils/babel-plugin-extract-graphql.js\",\"/vercel/path0/node_modules/react-hot-loader/babel.js\",\"/vercel/path0/node_modules/babel-plugin-add-module-exports/lib/index.js\",\"/vercel/path0/node_modules/babel-plugin-transform-object-assign/lib/index.js\",\"/vercel/path0/node_modules/babel-plugin-add-module-exports/lib/index.js\",\"/vercel/path0/node_modules/babel-plugin-transform-object-assign/lib/index.js\"],\"cacheDirectory\":true}!./src/pages/nestorone.js":
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports.pageQuery = undefined;
	
	var _templateObject = _taggedTemplateLiteralLoose(["\n  background-color: ", ";\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  justify-content: center;\n  padding: 6rem 4rem 6rem;\n  min-height: 70vh;\n\n  ", ";\n\n  ", ";\n"], ["\n  background-color: ", ";\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  justify-content: center;\n  padding: 6rem 4rem 6rem;\n  min-height: 70vh;\n\n  ", ";\n\n  ", ";\n"]),
	    _templateObject2 = _taggedTemplateLiteralLoose(["\n    flex-direction: row;\n    align-items: center;\n    justify-content: center;\n    text-align: center;\n    padding: 6rem 2rem 4rem;\n    min-height: 0;\n    gap: 1.5rem;\n  "], ["\n    flex-direction: row;\n    align-items: center;\n    justify-content: center;\n    text-align: center;\n    padding: 6rem 2rem 4rem;\n    min-height: 0;\n    gap: 1.5rem;\n  "]),
	    _templateObject3 = _taggedTemplateLiteralLoose(["\n    flex-direction: column;\n    padding: 6rem 1rem 0;\n    gap: 1rem;\n  "], ["\n    flex-direction: column;\n    padding: 6rem 1rem 0;\n    gap: 1rem;\n  "]),
	    _templateObject4 = _taggedTemplateLiteralLoose(["\n  text-align: left;\n  max-width: 520px;\n\n  ", ";\n"], ["\n  text-align: left;\n  max-width: 520px;\n\n  ", ";\n"]),
	    _templateObject5 = _taggedTemplateLiteralLoose(["\n    text-align: center;\n  "], ["\n    text-align: center;\n  "]),
	    _templateObject6 = _taggedTemplateLiteralLoose(["\n  width: 37vh;\n  height: 55vh;\n  flex-shrink: 0;\n  ", ";\n"], ["\n  width: 37vh;\n  height: 55vh;\n  flex-shrink: 0;\n  ", ";\n"]),
	    _templateObject7 = _taggedTemplateLiteralLoose(["display: none;"], ["display: none;"]),
	    _templateObject8 = _taggedTemplateLiteralLoose(["\n  display: none;\n  flex-shrink: 0;\n\n  ", ";\n\n  ", ";\n"], ["\n  display: none;\n  flex-shrink: 0;\n\n  ", ";\n\n  ", ";\n"]),
	    _templateObject9 = _taggedTemplateLiteralLoose(["\n    display: block;\n    width: 180px;\n    height: 260px;\n  "], ["\n    display: block;\n    width: 180px;\n    height: 260px;\n  "]),
	    _templateObject10 = _taggedTemplateLiteralLoose(["\n    width: 200px;\n    height: 280px;\n    margin: 0 auto;\n  "], ["\n    width: 200px;\n    height: 280px;\n    margin: 0 auto;\n  "]),
	    _templateObject11 = _taggedTemplateLiteralLoose(["\n  font-family: \"Palatino Linotype\", \"Book Antiqua\", Palatino, serif;\n  font-size: 3rem;\n  font-weight: bold;\n  color: ", ";\n  line-height: 1.15;\n  max-width: 520px;\n  margin: 0;\n\n  ", ";\n\n  ", ";\n"], ["\n  font-family: \"Palatino Linotype\", \"Book Antiqua\", Palatino, serif;\n  font-size: 3rem;\n  font-weight: bold;\n  color: ", ";\n  line-height: 1.15;\n  max-width: 520px;\n  margin: 0;\n\n  ", ";\n\n  ", ";\n"]),
	    _templateObject12 = _taggedTemplateLiteralLoose(["\n    font-size: 2.5rem;\n  "], ["\n    font-size: 2.5rem;\n  "]),
	    _templateObject13 = _taggedTemplateLiteralLoose(["\n    font-size: 2rem;\n  "], ["\n    font-size: 2rem;\n  "]),
	    _templateObject14 = _taggedTemplateLiteralLoose(["\n  font-family: \"Avenir Next\", \"Avenir\", Helvetica, Arial, sans-serif;\n  font-size: 1.35rem;\n  color: rgba(255, 255, 255, 0.65);\n  line-height: 1.7;\n  max-width: 420px;\n  margin: 1.25rem 0 0;\n\n  ", ";\n\n  ", ";\n"], ["\n  font-family: \"Avenir Next\", \"Avenir\", Helvetica, Arial, sans-serif;\n  font-size: 1.35rem;\n  color: rgba(255, 255, 255, 0.65);\n  line-height: 1.7;\n  max-width: 420px;\n  margin: 1.25rem 0 0;\n\n  ", ";\n\n  ", ";\n"]),
	    _templateObject15 = _taggedTemplateLiteralLoose(["\n    margin: 1.25rem auto 0;\n  "], ["\n    margin: 1.25rem auto 0;\n  "]),
	    _templateObject16 = _taggedTemplateLiteralLoose(["\n    font-size: 1.1rem;\n  "], ["\n    font-size: 1.1rem;\n  "]),
	    _templateObject17 = _taggedTemplateLiteralLoose(["\n  width: 48px;\n  height: 2px;\n  background: ", ";\n  margin: 2rem 0 0;\n\n  ", ";\n"], ["\n  width: 48px;\n  height: 2px;\n  background: ", ";\n  margin: 2rem 0 0;\n\n  ", ";\n"]),
	    _templateObject18 = _taggedTemplateLiteralLoose(["\n    margin: 2rem auto 0;\n  "], ["\n    margin: 2rem auto 0;\n  "]),
	    _templateObject19 = _taggedTemplateLiteralLoose(["\n  ", ";\n"], ["\n  ", ";\n"]),
	    _templateObject20 = _taggedTemplateLiteralLoose(["\n    padding-right: 0;\n  "], ["\n    padding-right: 0;\n  "]),
	    _templateObject21 = _taggedTemplateLiteralLoose(["\n  display: flex;\n  flex-direction: column;\n  gap: 2rem;\n  width: 100%;\n  padding: 2rem 0;\n"], ["\n  display: flex;\n  flex-direction: column;\n  gap: 2rem;\n  width: 100%;\n  padding: 2rem 0;\n"]),
	    _templateObject22 = _taggedTemplateLiteralLoose(["\n  display: flex;\n  align-items: flex-start;\n  gap: 1.5rem;\n\n  ", ";\n"], ["\n  display: flex;\n  align-items: flex-start;\n  gap: 1.5rem;\n\n  ", ";\n"]),
	    _templateObject23 = _taggedTemplateLiteralLoose(["\n    flex-direction: column;\n    align-items: flex-start;\n    text-align: left;\n  "], ["\n    flex-direction: column;\n    align-items: flex-start;\n    text-align: left;\n  "]),
	    _templateObject24 = _taggedTemplateLiteralLoose(["\n  width: 48px;\n  height: 48px;\n  min-width: 48px;\n  border-radius: 50%;\n  background-color: ", ";\n  color: white;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-weight: bold;\n  font-size: 1.25rem;\n"], ["\n  width: 48px;\n  height: 48px;\n  min-width: 48px;\n  border-radius: 50%;\n  background-color: ", ";\n  color: white;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-weight: bold;\n  font-size: 1.25rem;\n"]),
	    _templateObject25 = _taggedTemplateLiteralLoose(["flex: 1;"], ["flex: 1;"]),
	    _templateObject26 = _taggedTemplateLiteralLoose(["\n  font-family: \"Palatino Linotype\", \"Book Antiqua\", Palatino, serif;\n  font-size: 1.5rem;\n  line-height: 1.6;\n  font-style: italic;\n  text-align: center;\n  max-width: 600px;\n  margin: 0 auto;\n  color: ", ";\n\n  ", ";\n"], ["\n  font-family: \"Palatino Linotype\", \"Book Antiqua\", Palatino, serif;\n  font-size: 1.5rem;\n  line-height: 1.6;\n  font-style: italic;\n  text-align: center;\n  max-width: 600px;\n  margin: 0 auto;\n  color: ", ";\n\n  ", ";\n"]),
	    _templateObject27 = _taggedTemplateLiteralLoose(["\n    font-size: 1.25rem;\n  "], ["\n    font-size: 1.25rem;\n  "]),
	    _templateObject28 = _taggedTemplateLiteralLoose(["\n  width: 320px;\n  height: 320px;\n  border-radius: 8px;\n  object-fit: cover;\n"], ["\n  width: 320px;\n  height: 320px;\n  border-radius: 8px;\n  object-fit: cover;\n"]),
	    _templateObject29 = _taggedTemplateLiteralLoose(["\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: 0.5rem;\n  margin-top: 1.5rem;\n  justify-content: center;\n"], ["\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: 0.5rem;\n  margin-top: 1.5rem;\n  justify-content: center;\n"]),
	    _templateObject30 = _taggedTemplateLiteralLoose(["\n  from { opacity: 0; transform: translateY(8px); }\n  to { opacity: 1; transform: translateY(0); }\n"], ["\n  from { opacity: 0; transform: translateY(8px); }\n  to { opacity: 1; transform: translateY(0); }\n"]),
	    _templateObject31 = _taggedTemplateLiteralLoose(["\n  0%, 100% { box-shadow: 0 0 0 0 rgba(67, 188, 186, 0); }\n  50% { box-shadow: 0 0 20px 4px rgba(67, 188, 186, 0.15); }\n"], ["\n  0%, 100% { box-shadow: 0 0 0 0 rgba(67, 188, 186, 0); }\n  50% { box-shadow: 0 0 20px 4px rgba(67, 188, 186, 0.15); }\n"]),
	    _templateObject32 = _taggedTemplateLiteralLoose(["\n  0% { background-position: 200% center; }\n  100% { background-position: -200% center; }\n"], ["\n  0% { background-position: 200% center; }\n  100% { background-position: -200% center; }\n"]),
	    _templateObject33 = _taggedTemplateLiteralLoose(["\n  0% { clip-path: inset(0 100% 0 0); }\n  100% { clip-path: inset(0 0 0 0); }\n"], ["\n  0% { clip-path: inset(0 100% 0 0); }\n  100% { clip-path: inset(0 0 0 0); }\n"]),
	    _templateObject34 = _taggedTemplateLiteralLoose(["\n  border-radius: 2rem;\n  padding: 0.75rem 2rem;\n  max-width: 520px;\n  text-align: center;\n  font-family: \"Avenir Next\", \"Avenir\", Helvetica, Arial, sans-serif;\n  font-size: 1rem;\n  line-height: 1.5;\n  animation: ", " 0.6s ease-out both;\n"], ["\n  border-radius: 2rem;\n  padding: 0.75rem 2rem;\n  max-width: 520px;\n  text-align: center;\n  font-family: \"Avenir Next\", \"Avenir\", Helvetica, Arial, sans-serif;\n  font-size: 1rem;\n  line-height: 1.5;\n  animation: ", " 0.6s ease-out both;\n"]),
	    _templateObject35 = _taggedTemplateLiteralLoose(["\n  background: #f7fafa;\n  color: #000914;\n  border: 1px solid #43bcba;\n  animation: ", " 0.6s ease-out both, ", " 3s ease-in-out 1s infinite;\n"], ["\n  background: #f7fafa;\n  color: #000914;\n  border: 1px solid #43bcba;\n  animation: ", " 0.6s ease-out both, ", " 3s ease-in-out 1s infinite;\n"]),
	    _templateObject36 = _taggedTemplateLiteralLoose(["\n  background: linear-gradient(\n    105deg,\n    #000914 0%, #000914 40%, #0f2828 48%, #163636 50%, #0f2828 52%, #000914 60%, #000914 100%\n  );\n  background-size: 300% 100%;\n  color: white;\n  opacity: 0;\n  animation: ", " 0.6s ease-out 0.5s both, ", " 10s ease-in-out 1.1s infinite;\n"], ["\n  background: linear-gradient(\n    105deg,\n    #000914 0%, #000914 40%, #0f2828 48%, #163636 50%, #0f2828 52%, #000914 60%, #000914 100%\n  );\n  background-size: 300% 100%;\n  color: white;\n  opacity: 0;\n  animation: ", " 0.6s ease-out 0.5s both, ", " 10s ease-in-out 1.1s infinite;\n"]),
	    _templateObject37 = _taggedTemplateLiteralLoose(["\n  0%, 100% { transform: translateY(0); }\n  50% { transform: translateY(-3px); }\n"], ["\n  0%, 100% { transform: translateY(0); }\n  50% { transform: translateY(-3px); }\n"]),
	    _templateObject38 = _taggedTemplateLiteralLoose(["\n  background: linear-gradient(135deg, #43bcba, #3ecfcd);\n  color: white;\n  font-weight: 600;\n  animation: ", " 0.6s ease-out both, ", " 4s ease-in-out 1s infinite;\n"], ["\n  background: linear-gradient(135deg, #43bcba, #3ecfcd);\n  color: white;\n  font-weight: 600;\n  animation: ", " 0.6s ease-out both, ", " 4s ease-in-out 1s infinite;\n"]),
	    _templateObject39 = _taggedTemplateLiteralLoose(["\n  background: transparent;\n  color: #000914;\n  position: relative;\n  border: 2px solid #43bcba;\n  animation: ", " 0.8s ease-out both, ", " 1s ease-out both;\n"], ["\n  background: transparent;\n  color: #000914;\n  position: relative;\n  border: 2px solid #43bcba;\n  animation: ", " 0.8s ease-out both, ", " 1s ease-out both;\n"]),
	    _templateObject40 = _taggedTemplateLiteralLoose(["\n  from { width: 0; }\n  to { width: 60%; }\n"], ["\n  from { width: 0; }\n  to { width: 60%; }\n"]),
	    _templateObject41 = _taggedTemplateLiteralLoose(["\n  max-width: 520px;\n  text-align: center;\n  animation: ", " 0.6s ease-out both;\n"], ["\n  max-width: 520px;\n  text-align: center;\n  animation: ", " 0.6s ease-out both;\n"]),
	    _templateObject42 = _taggedTemplateLiteralLoose(["\n  height: 2px;\n  background: linear-gradient(90deg, transparent, #43bcba, transparent);\n  margin: 0.5rem auto 0;\n  animation: ", " 1.2s ease-out 0.6s both;\n"], ["\n  height: 2px;\n  background: linear-gradient(90deg, transparent, #43bcba, transparent);\n  margin: 0.5rem auto 0;\n  animation: ", " 1.2s ease-out 0.6s both;\n"]),
	    _templateObject43 = _taggedTemplateLiteralLoose(["\n    padding-top: 32px;\n  "], ["\n    padding-top: 32px;\n  "]),
	    _templateObject44 = _taggedTemplateLiteralLoose(["\n  text-align: center;\n  margin-top: 8rem;\n  opacity: 0;\n  animation: ", " 0.6s ease-out 1s both;\n  color: #c3c3c3;\n  font-size: 1.5rem;\n"], ["\n  text-align: center;\n  margin-top: 8rem;\n  opacity: 0;\n  animation: ", " 0.6s ease-out 1s both;\n  color: #c3c3c3;\n  font-size: 1.5rem;\n"]);
	
	var _react = __webpack_require__("./node_modules/gatsby-plugin-react-next/node_modules/react/index.js");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _styledComponents = __webpack_require__("./node_modules/styled-components/lib/index.js");
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _reactHelmet = __webpack_require__("./node_modules/react-helmet/lib/Helmet.js");
	
	var _reactHelmet2 = _interopRequireDefault(_reactHelmet);
	
	var _typography = __webpack_require__("./src/components/typography/index.js");
	
	var _Emphasis = __webpack_require__("./src/components/atoms/Emphasis.js");
	
	var _Emphasis2 = _interopRequireDefault(_Emphasis);
	
	var _NavBar = __webpack_require__("./src/components/NavBar.js");
	
	var _NavBar2 = _interopRequireDefault(_NavBar);
	
	var _Button = __webpack_require__("./src/components/atoms/Button.js");
	
	var _Spacer = __webpack_require__("./src/components/blocks/Spacer.js");
	
	var _Spacer2 = _interopRequireDefault(_Spacer);
	
	var _Section = __webpack_require__("./src/components/blocks/Section.js");
	
	var _Section2 = _interopRequireDefault(_Section);
	
	var _FadeIn = __webpack_require__("./src/components/atoms/FadeIn.js");
	
	var _FadeIn2 = _interopRequireDefault(_FadeIn);
	
	var _PublicationStyles = __webpack_require__("./src/components/PublicationStyles.js");
	
	var _selectors = __webpack_require__("./src/selectors.js");
	
	var _logofavcon2x = __webpack_require__("./assets/logofavcon@2x.png");
	
	var _logofavcon2x2 = _interopRequireDefault(_logofavcon2x);
	
	var _matthewNest = __webpack_require__("./matthew-nest.png");
	
	var _matthewNest2 = _interopRequireDefault(_matthewNest);
	
	var _foamHand = __webpack_require__("./assets/foam-hand.png");
	
	var _foamHand2 = _interopRequireDefault(_foamHand);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	function _taggedTemplateLiteralLoose(strings, raw) { strings.raw = raw; return strings; }
	
	// -- Minimal custom styles (hero + stats only) --
	
	var HeroBg = _styledComponents2.default.div(_templateObject, function (props) {
	  return props.theme.colors.dark;
	}, function (props) {
	  return props.theme.media.tablet(_templateObject2);
	}, function (props) {
	  return props.theme.media.mobile(_templateObject3);
	});
	
	var HeroText = _styledComponents2.default.div(_templateObject4, function (props) {
	  return props.theme.media.tablet(_templateObject5);
	});
	
	var HideMobileWrap = _styledComponents2.default.div(_templateObject6, function (props) {
	  return props.theme.media.tablet(_templateObject7);
	});
	
	var CanisterInline = _styledComponents2.default.div(_templateObject8, function (props) {
	  return props.theme.media.tablet(_templateObject9);
	}, function (props) {
	  return props.theme.media.mobile(_templateObject10);
	});
	
	var HeroHeadline = _styledComponents2.default.h2(_templateObject11, function (props) {
	  return props.theme.colors.white;
	}, function (props) {
	  return props.theme.media.tablet(_templateObject12);
	}, function (props) {
	  return props.theme.media.mobile(_templateObject13);
	});
	
	var HeroSub = _styledComponents2.default.p(_templateObject14, function (props) {
	  return props.theme.media.tablet(_templateObject15);
	}, function (props) {
	  return props.theme.media.mobile(_templateObject16);
	});
	
	var TealLine = _styledComponents2.default.div(_templateObject17, function (props) {
	  return props.theme.colors.teal;
	}, function (props) {
	  return props.theme.media.tablet(_templateObject18);
	});
	
	var HowItWorksWrap = _styledComponents2.default.div(_templateObject19, function (props) {
	  return props.theme.media.tablet(_templateObject20);
	});
	
	var StepList = _styledComponents2.default.div(_templateObject21);
	
	var Step = _styledComponents2.default.div(_templateObject22, function (props) {
	  return props.theme.media.mobile(_templateObject23);
	});
	
	var StepNumber = _styledComponents2.default.div(_templateObject24, function (props) {
	  return props.theme.colors.teal;
	});
	
	var StepContent = _styledComponents2.default.div(_templateObject25);
	
	var TestimonialQuote = _styledComponents2.default.blockquote(_templateObject26, function (props) {
	  return props.theme.colors.dark;
	}, function (props) {
	  return props.theme.media.mobile(_templateObject27);
	});
	
	var TestimonialAvatar = _styledComponents2.default.img(_templateObject28);
	
	var TestimonialAttribution = _styledComponents2.default.div(_templateObject29);
	
	// -- Announcement pill variants --
	
	var defaultPillText = "Contraline has acquired an exclusive license to NES/T and is advancing towards a global Phase 3 trial.";
	
	var fadeIn = (0, _styledComponents.keyframes)(_templateObject30);
	
	var pulseGlow = (0, _styledComponents.keyframes)(_templateObject31);
	
	var shimmerPill = (0, _styledComponents.keyframes)(_templateObject32);
	
	var borderDraw = (0, _styledComponents.keyframes)(_templateObject33);
	
	var PillBase = _styledComponents2.default.div(_templateObject34, fadeIn);
	
	// A: Subtle teal glow pulse
	var PillA = PillBase.extend(_templateObject35, fadeIn, pulseGlow);
	
	// B: Dark with shimmer sweep
	var PillB = PillBase.extend(_templateObject36, fadeIn, shimmerPill);
	
	// C: Teal gradient with soft float
	var floatUp = (0, _styledComponents.keyframes)(_templateObject37);
	
	var PillC = PillBase.extend(_templateObject38, fadeIn, floatUp);
	
	// D: Border draws in, then fades content
	var PillD = PillBase.extend(_templateObject39, fadeIn, borderDraw);
	
	// E: Light with animated teal underline
	var underlineGrow = (0, _styledComponents.keyframes)(_templateObject40);
	
	var PillEWrap = _styledComponents2.default.div(_templateObject41, fadeIn);
	
	var PillELine = _styledComponents2.default.div(_templateObject42, underlineGrow);
	
	var PublicationsHeader = _styledComponents2.default.div(_templateObject19, function (props) {
	  return props.theme.media.mobile(_templateObject43);
	});
	
	var Chevron = _styledComponents2.default.div(_templateObject44, fadeIn);
	
	var AnnouncementVariants = function AnnouncementVariants(_ref) {
	  var text = _ref.text;
	  return _react2.default.createElement(
	    "div",
	    { style: { display: "flex", flexDirection: "column", alignItems: "center" } },
	    _react2.default.createElement(
	      PillB,
	      null,
	      text
	    )
	  );
	};
	
	// -- Page --
	
	var NestoronePage = function (_React$Component) {
	  _inherits(NestoronePage, _React$Component);
	
	  function NestoronePage() {
	    _classCallCheck(this, NestoronePage);
	
	    return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
	  }
	
	  NestoronePage.prototype.render = function render() {
	    var data = this.props.data;
	    var content = data ? (0, _selectors.getGraphNode)(data, "NesteronePage") : null;
	
	    var heroHeadline = content && content.heroHeadline || "Introducing NES/T";
	    var heroSubtitle = content && content.heroSubtitle && content.heroSubtitle.heroSubtitle || "A daily topical gel for male contraception. Fully reversible & effective in weeks.";
	    var metaDescription = content && content.metaDescription && content.metaDescription.metaDescription || "NES/T Gel - A daily topical contraceptive for men. Reversible, effective, and easy to use.";
	    var pillTextValue = content && content.pillText && content.pillText.pillText || defaultPillText;
	    var howItWorksTitle = content && content.howItWorksTitle || "How NES/T Works";
	    var step1Title = content && content.step1Title || "Apply once a day";
	    var step1Body = content && content.step1Body && content.step1Body.step1Body || "On the shoulders and upper arms \u2013 morning or night. The pump delivers the same amount every time and it dries fast, so it fits easily into your routine.";
	    var step2Title = content && content.step2Title || "Two FDA-approved hormones, one purpose";
	    var step2Body = content && content.step2Body && content.step2Body.step2Body || "NES/T combines two hormones that work together. One temporarily pauses sperm production. The other maintains normal testosterone levels to support energy, mood, and sex drive. Designed for no trade-offs.";
	    var step3Title = content && content.step3Title || "Reliable and reversible";
	    var step3Body = content && content.step3Body && content.step3Body.step3Body || "Most men reach contraceptive levels in about two months. When you stop using the gel, sperm production gradually returns to normal.";
	    var statusHeadline = content && content.statusHeadline && content.statusHeadline.statusHeadline || "NES/T Gel completed Phase 2b trials in 2024 with 462 couples, 0 pregnancies.";
	    var statusSubheadline = content && content.statusSubheadline || "Phase three trials are anticipated to begin in 2026.";
	    var testimonialQuote = content && content.testimonialQuote && content.testimonialQuote.testimonialQuote || "I've only experienced increased libido. Maybe I'm just lucking out but I hope this is the case for the majority of participants. If it is, it's definitely going to change contraception as a whole.";
	    var testimonialName = content && content.testimonialName || "Matthew Trevi\xF1o";
	    var testimonialTitleText = content && content.testimonialTitle || "Phase 2b Trial Participant";
	    var testimonialImageSrc = content && content.testimonialImage && content.testimonialImage.responsiveResolution ? content.testimonialImage.responsiveResolution.src : _matthewNest2.default;
	    var publicationsTitle = content && content.publicationsTitle || "Publications";
	    var publicationsDescription = content && content.publicationsDescription && content.publicationsDescription.publicationsDescription || "Selected research on NES/T Gel and combined hormonal male contraception.";
	    var publications = content && content.publications;
	    var ctaHeadline = content && content.ctaHeadline && content.ctaHeadline.ctaHeadline || "Effective, reversible contraception \u2014 on your terms.";
	    var ctaButtonText = content && content.ctaButtonText || "Interested in the NES/T Trial?";
	    var ctaButtonLink = content && content.ctaButtonLink || "/participate";
	    var heroImageSrc = content && content.heroImage && content.heroImage.responsiveResolution ? content.heroImage.responsiveResolution.src : _foamHand2.default;
	
	    return _react2.default.createElement(
	      "div",
	      null,
	      _react2.default.createElement(
	        _reactHelmet2.default,
	        {
	          title: "NES/T Gel - Contraline",
	          meta: [{
	            name: "description",
	            content: metaDescription
	          }]
	        },
	        _react2.default.createElement("link", { rel: "icon", type: "image/png", href: _logofavcon2x2.default })
	      ),
	      _react2.default.createElement(_NavBar2.default, { color: "white", background: "dark" }),
	      _react2.default.createElement(
	        HeroBg,
	        null,
	        _react2.default.createElement(
	          HeroText,
	          null,
	          _react2.default.createElement(
	            _FadeIn2.default,
	            null,
	            _react2.default.createElement(
	              HeroHeadline,
	              null,
	              heroHeadline
	            ),
	            _react2.default.createElement(
	              HeroSub,
	              null,
	              heroSubtitle
	            ),
	            _react2.default.createElement(TealLine, null)
	          )
	        ),
	        _react2.default.createElement(
	          HideMobileWrap,
	          null,
	          _react2.default.createElement("img", { src: heroImageSrc, alt: "NES/T Gel", style: { maxHeight: "55vh", objectFit: "contain" } })
	        ),
	        _react2.default.createElement(
	          CanisterInline,
	          null,
	          _react2.default.createElement("img", { src: heroImageSrc, alt: "NES/T Gel", style: { width: "100%", height: "100%", objectFit: "contain" } })
	        )
	      ),
	      _react2.default.createElement(
	        _Section2.default,
	        { color: "white", narrow: true },
	        _react2.default.createElement(
	          "div",
	          null,
	          _react2.default.createElement(_Spacer2.default, { span: 4 }),
	          _react2.default.createElement(
	            HowItWorksWrap,
	            null,
	            _react2.default.createElement(
	              _Emphasis2.default,
	              null,
	              _react2.default.createElement(
	                _typography.H4,
	                null,
	                howItWorksTitle
	              )
	            ),
	            _react2.default.createElement(
	              StepList,
	              null,
	              _react2.default.createElement(
	                Step,
	                null,
	                _react2.default.createElement(
	                  StepNumber,
	                  null,
	                  "1"
	                ),
	                _react2.default.createElement(
	                  StepContent,
	                  null,
	                  _react2.default.createElement(
	                    _typography.P,
	                    null,
	                    _react2.default.createElement(
	                      "strong",
	                      null,
	                      step1Title
	                    )
	                  ),
	                  _react2.default.createElement(
	                    _typography.P,
	                    null,
	                    step1Body
	                  )
	                )
	              ),
	              _react2.default.createElement(
	                Step,
	                null,
	                _react2.default.createElement(
	                  StepNumber,
	                  null,
	                  "2"
	                ),
	                _react2.default.createElement(
	                  StepContent,
	                  null,
	                  _react2.default.createElement(
	                    _typography.P,
	                    null,
	                    _react2.default.createElement(
	                      "strong",
	                      null,
	                      step2Title
	                    )
	                  ),
	                  _react2.default.createElement(
	                    _typography.P,
	                    null,
	                    step2Body
	                  )
	                )
	              ),
	              _react2.default.createElement(
	                Step,
	                null,
	                _react2.default.createElement(
	                  StepNumber,
	                  null,
	                  "3"
	                ),
	                _react2.default.createElement(
	                  StepContent,
	                  null,
	                  _react2.default.createElement(
	                    _typography.P,
	                    null,
	                    _react2.default.createElement(
	                      "strong",
	                      null,
	                      step3Title
	                    )
	                  ),
	                  _react2.default.createElement(
	                    _typography.P,
	                    null,
	                    step3Body
	                  )
	                )
	              )
	            )
	          ),
	          _react2.default.createElement(_Spacer2.default, { span: 4 })
	        )
	      ),
	      _react2.default.createElement(
	        _Section2.default,
	        { color: "greyLight", align: "center" },
	        _react2.default.createElement(_Spacer2.default, { span: 6 }),
	        _react2.default.createElement(
	          _typography.H3,
	          { serif: true, weight: "bold", align: "center", style: { lineHeight: 1.5, marginBottom: "0.25rem" } },
	          statusHeadline
	        ),
	        statusSubheadline && _react2.default.createElement(
	          _typography.H3,
	          { serif: true, weight: "bold", align: "center", style: { lineHeight: 1.5, marginTop: 0 } },
	          statusSubheadline
	        ),
	        _react2.default.createElement(_Spacer2.default, { span: 6 }),
	        _react2.default.createElement(
	          TestimonialQuote,
	          null,
	          "\"",
	          testimonialQuote,
	          "\""
	        ),
	        _react2.default.createElement(
	          TestimonialAttribution,
	          null,
	          _react2.default.createElement(TestimonialAvatar, { src: testimonialImageSrc, alt: testimonialName }),
	          _react2.default.createElement(
	            "div",
	            { style: { textAlign: "center" } },
	            _react2.default.createElement(
	              _typography.P,
	              { color: "dark", align: "center", style: { paddingBottom: 0 } },
	              testimonialName,
	              " & Emily Fletcher"
	            ),
	            _react2.default.createElement(
	              _typography.P,
	              {
	                color: "greyDark",
	                align: "center",
	                style: { fontSize: "0.9rem", paddingBottom: 0 }
	              },
	              testimonialTitleText
	            )
	          )
	        ),
	        _react2.default.createElement(_Spacer2.default, { span: 6 })
	      ),
	      _react2.default.createElement(
	        _Section2.default,
	        { color: "white", narrow: true, align: "center" },
	        _react2.default.createElement(
	          PublicationsHeader,
	          null,
	          _react2.default.createElement(
	            _typography.H3,
	            { serif: true, weight: "bold", align: "center" },
	            publicationsTitle
	          )
	        ),
	        _react2.default.createElement(
	          _typography.P,
	          {
	            align: "center",
	            color: "greyDark",
	            style: { marginBottom: "2rem" }
	          },
	          publicationsDescription
	        ),
	        _react2.default.createElement(_PublicationStyles.Editorial, { publications: publications }),
	        _react2.default.createElement(_Spacer2.default, { span: 4 })
	      ),
	      _react2.default.createElement(
	        _Section2.default,
	        { color: "white", narrow: true },
	        _react2.default.createElement(_Spacer2.default, { span: 4 }),
	        _react2.default.createElement(
	          _FadeIn2.default,
	          null,
	          _react2.default.createElement(
	            _typography.H3,
	            { serif: true, weight: "bold", align: "center" },
	            ctaHeadline
	          ),
	          _react2.default.createElement(_Spacer2.default, { span: 2 }),
	          _react2.default.createElement(
	            "div",
	            { style: { textAlign: "center", width: "100%" } },
	            _react2.default.createElement(
	              _Button.InternalButton,
	              { to: ctaButtonLink },
	              ctaButtonText
	            )
	          )
	        ),
	        _react2.default.createElement(_Spacer2.default, { span: 8 })
	      )
	    );
	  };
	
	  return NestoronePage;
	}(_react2.default.Component);
	
	exports.default = NestoronePage;
	var pageQuery = exports.pageQuery = "** extracted graphql fragment **";

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-nestorone-js-368f630eb3b75ca4c722.js